export function canDeleteTree(nodes) {
    return [...nodes].filter(
        node => this.actions.canDeleteTree(node)
    )
}

export async function deleteTree(nodes) {
    await this.execute(
        () => this.actions.deleteTree(nodes)
    )
}
